import { ButtonSecondary } from 'fukku/Button/Secondary'
import { ClientLabel } from 'labels/client'
import { useLabels } from 'labels/hooks/useLabels/useLabels'

import styles from './OnlineReturnsInfo.module.scss'

interface OnlineReturnsProps {
	readonly handleOpenReturnsModal: () => void
	readonly maximumReturnDays: number
	readonly returnDate?: string
}
export function OnlineReturnsInfo({
	maximumReturnDays,
	returnDate,
	handleOpenReturnsModal,
}: OnlineReturnsProps) {
	const { t } = useLabels()

	return (
		<>
			{!returnDate && (
				<p className={styles.info}>
					<ClientLabel
						placeholderValues={{
							1: maximumReturnDays,
						}}
					>
						{t('myPurchases.online.details.returns.returnDays.bodycopy') ?? ''}
					</ClientLabel>
				</p>
			)}
			<div>
				{returnDate && (
					<ClientLabel
						placeholderValues={{
							1: returnDate,
						}}
					>
						{t('myPurchases.online.details.returnDate.text')}
					</ClientLabel>
				)}
				<ButtonSecondary
					data-testid='myPurchases.returns.button'
					onClick={handleOpenReturnsModal}
					className={styles.returnsButton}
				>
					{t('myPurchases.details.exchangesReturns.buttom.title')}
				</ButtonSecondary>
			</div>
		</>
	)
}
